import { render, staticRenderFns } from "./Tarjetas.vue?vue&type=template&id=fe3c208a"
import script from "./Tarjetas.vue?vue&type=script&lang=js"
export * from "./Tarjetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports